import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {reverse} from 'core/urls';
import styles from './styles.css';

export default class ViewAllProductsLink extends Component {
    static propTypes = {
        text: PropTypes.string,
    };

    static defaultProps = {
        text: 'Ver todos los productos',
    };

    render() {
        return (
            <Link to={reverse('merchandising')} className={styles.root}>
                <i className='material-icons'>apps</i> {this.props.text}
            </Link>
        );
    }
}



// WEBPACK FOOTER //
// ./components/view-all-products-link/index.js